<h2 mat-dialog-title>Agregar Familiar</h2>
<mat-dialog-content>
  <form [formGroup]="familiarForm" class="familiar-form">
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Parentesco</mat-label>
        <mat-select formControlName="parentesco">
          <mat-option [value]="Parentesco.Esposo">Esposo/a</mat-option>
          <mat-option [value]="Parentesco.Concubino">Concubino/a</mat-option>
          <mat-option [value]="Parentesco.Hijo">Hijo/a</mat-option>
        </mat-select>
        <mat-error *ngIf="familiarForm.get('parentesco')?.hasError('required')">
          El parentesco es requerido
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Nacionalidad</mat-label>
        <mat-select formControlName="nacionalidad">
          <mat-option [value]="Nacionalidad.Argentino">Argentino/a</mat-option>
          <mat-option [value]="Nacionalidad.Extranjero">Extranjero/a</mat-option>
        </mat-select>
        <mat-error *ngIf="familiarForm.get('nacionalidad')?.hasError('required')">
          La nacionalidad es requerida
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Nombre</mat-label>
        <input matInput formControlName="nombre">
        <mat-error *ngIf="familiarForm.get('nombre')?.hasError('required')">
          El nombre es requerido
        </mat-error>
        <mat-error *ngIf="familiarForm.get('nombre')?.hasError('pattern')">
          Solo letras, apóstrofes y espacios. Máximo 50 caracteres.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Apellido</mat-label>
        <input matInput formControlName="apellido">
        <mat-error *ngIf="familiarForm.get('apellido')?.hasError('required')">
          El apellido es requerido
        </mat-error>
        <mat-error *ngIf="familiarForm.get('apellido')?.hasError('pattern')">
          Solo letras, apóstrofes y espacios. Máximo 50 caracteres.
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Fecha de Nacimiento</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="fechaNacimiento">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="familiarForm.get('fechaNacimiento')?.hasError('required')">
          La fecha de nacimiento es requerida
        </mat-error>
        <mat-error *ngIf="familiarForm.get('fechaNacimiento')?.hasError('hijoMayorQueTitular')">
          La fecha de nacimiento del hijo no puede ser anterior o igual a la del titular.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Sexo</mat-label>
        <mat-select formControlName="sexo">
          <mat-option [value]="Sexo.Masculino">Masculino</mat-option>
          <mat-option [value]="Sexo.Femenino">Femenino</mat-option>
        </mat-select>
        <mat-error *ngIf="familiarForm.get('sexo')?.hasError('required')">
          El sexo es requerido
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>CUIL</mat-label>
        <input matInput formControlName="cuil">
        <mat-error *ngIf="familiarForm.get('cuil')?.hasError('required')">
          El CUIL es requerido
        </mat-error>
        <mat-error *ngIf="familiarForm.get('cuil')?.hasError('pattern')">
          Solo números, máximo 12 dígitos
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Número de Documento</mat-label>
        <input matInput formControlName="numeroDocumento">
        <mat-error *ngIf="familiarForm.get('numeroDocumento')?.hasError('required')">
          El número de documento es requerido
        </mat-error>
        <mat-error *ngIf="familiarForm.get('numeroDocumento')?.hasError('pattern')">
          Solo números, máximo 10 dígitos
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Incapacidad</mat-label>
        <mat-select formControlName="incapacidad">
          <mat-option [value]="true">Sí</mat-option>
          <mat-option [value]="false">No</mat-option>
        </mat-select>
        <mat-error *ngIf="familiarForm.get('incapacidad')?.hasError('required')">
          Este campo es requerido
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row" *ngIf="esMayorDeEdad()">
      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email">
        <mat-error *ngIf="familiarForm.get('email')?.hasError('pattern')">
          Formato de email inválido. Debe contener @ y un dominio válido.
        </mat-error>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancelar()">Cancelar</button>
  <button mat-raised-button color="primary" (click)="guardar()" [disabled]="!familiarForm.valid">Guardar</button>
</mat-dialog-actions>